import React from 'react'
import AllStudyMaterials from '../../../components/jsx/learnings/StudyMaterial/AllStudyMaterials'

const StudyMaterial = () => {
  return (
    <div><AllStudyMaterials/></div>
  )
}

export default StudyMaterial